import * as React from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import { inject, observer } from 'mobx-react';
import { usePageData } from '@bernie/page-context';
import { useAffiliatesContext } from 'bernie-plugin-affiliate-context';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { Stripe } from '@shared-ui/retail-affiliates-stripe';
import { usePlatformContext } from '@bernie/platform-context';
var EGStripe = inject('page')(observer(function (_a) {
    var page = _a.page, fullWidth = _a.fullWidth;
    var pageDataContext = usePageData().pageDataContext;
    var context = usePlatformContext().context;
    var location = useLocation();
    var site = context.site;
    /**
     * TODO: Revisit once `@bernie/page-context@>=2.1.0` types available in all targeted integration Bernie apps
     * - Remove fallback to page store from bernie-plugin-mobx
     * - Destructure `pageDataContext` values
     */
    var pageId = (pageDataContext && pageDataContext.pageId) || (page === null || page === void 0 ? void 0 : page.pageId) || '';
    // Trigger re-render on url changes
    var targetUrl = React.useMemo(function () {
        return (typeof window !== 'undefined' && window.location.href) || '';
    }, [location]);
    var containerClass = React.useMemo(function () {
        if (fullWidth) {
            return 'eg-stripe-toolbar-container';
        }
        return 'eg-stripe-toolbar-container global_navigation__header__default__max_width';
    }, [fullWidth]);
    var affiliatesContext = useAffiliatesContext();
    if (!affiliatesContext || !affiliatesContext.isLinkToolbarAvailable) {
        return null;
    }
    return (React.createElement(Experiment, { name: "EG_Affiliates_Link_Toolbar" },
        React.createElement(ExperimentControl, null),
        React.createElement(ExperimentVariant, { bucket: 1 },
            React.createElement("div", { className: "eg-stripe-toolbar" },
                React.createElement("div", { className: containerClass },
                    React.createElement(Stripe, { inputs: { pageId: pageId, site: site, targetUrl: targetUrl } }))))));
}));
export { EGStripe };
//# sourceMappingURL=eg-stripe.js.map